export default __webpack_public_path__ + "static/media/coldhot.f56e4382.jpeg";